// @flow strict

export const de = {
  _blog_title: 'Alle Artikel',
  _blog_description:
    'Aktuelle Kundenservice News und Tipps zur Automatisierung, Chatbots, Self Service und vieles mehr.',
  _blog_read_more: 'weiterlesen',

  _blog_intro_headline: 'Hallo zusammen.',
  _blog_intro_text:
    'Aktuelle Kundenservice News und Tipps zur Automatisierung, Chatbots, Self Service und vieles mehr.',

  _blog_all_intro_headline: 'Hallo zusammen.',
  _blog_all_intro_text:
    'Aktuelle Kundenservice News und Tipps zur Automatisierung, Chatbots, Self Service und vieles mehr',

  _about_us_teaser: 'Über uns',
  _about_us_headline: 'Wir lieben Kundenservice',
  _about_us_text:
    'Seit 10 Jahren sind wir die Pioniere im Bereich Kundenservice Automatisierung und Künstliche Intelligenz. Hier möchten wir das Expertenwissen und die Erfahrungen mit unserem Kunden, die wir bereits sammeln konnten, mit euch teilen. :)',
  _about_us_see_all: 'Alle Autoren',
  _about_us_see_more_posts: 'Mehr Artikel sehen',

  _author_no_author: 'Kein Author',
  _author_time_to_read: 'Minuten',
  _author_updated: 'Aktualisiert am',
  _author_read_all: 'Alle Artikel',
  _author_latest_posts: 'Neuster Artikel von',

  _authors_title: 'Autoren',
  _authors_description:
    'Das OMQ Autoren-Team ist ein vielfältiges Team, das über Themen wie Kundenservice, Künstliche Intelligenz, Automatisierung und NLP-Technologie schreibt.',

  _menu_magazine: 'Magazine',
  _menu_products: 'Produkte',
  _menu_company: 'Unternehmen',
  _menu_about_us: 'Über uns',
  _menu_jobs: 'Jobs',
  _menu_imprint: 'Impressum',
  _menu_privacy_policy: 'Datenschutz',
  _menu_contact: 'Kontakt',

  _navigation_cta_button: 'Jetzt testen',

  _helping_hands_see_more: 'Weiterlesen',

  _newsletter_title: 'Magazine Newsletter',
  _newsletter_description:
    'Immer die neusten Tipps und Tutorials, um deinen Kundenservice zu verbessern und zu optimieren.',
  _newsletter_input: 'E-Mail',
  _newsletter_submit: 'Zum Newsletter anmelden',
  _newsletter_private_policy:
    'Ich habe die Datenschutzerklärung von <a href="/de/unternehmen/datenschutz/" title="OMQ Datenschutzbestimmungen">OMQ</a> zur Kenntnis genommen.',
  _newsletter_missing_privacy_check:
    'Bitte bestätigen Sie, dass Sie die Datenschutzerklärung zur Kenntnis genommen haben',

  _search_title: 'Suche',
  _search_description:
    'Hier können Sie Artikel über Themen wie Kundenservice Automatisierung, Chatbots, Self Service, Künstliche Intelligenz oder NLP suchen.',
  _search_field_placeholder: 'Suche in magazine...',
  _search_result: 'Suchergebnisse für: ',
  _search_most_popular_tags: 'Beliebteste tags',
  _search_articles_by_category: 'Kategorien',
  _search_menu_item: 'Durchsuche den Blog',

  _names_products_contact: 'Smartes Kontaktformular',
  _names_products_help: 'Intelligente Hilfeseite',
  _names_products_assist: 'Ticketsystem Assistent',
  _names_products_reply: 'KI E-Mail Bot',
  _names_products_chatbot: 'KI-Chatbot',
  _names_products_ai_agents: 'AI Agent',

  _links_products_contact: '/de/produkte/contact/',
  _links_products_help: '/de/produkte/help/',
  _links_products_assist: '/de/produkte/assist/',
  _links_products_reply: '/de/produkte/reply/',
  _links_products_chatbot: '/de/produkte/chatbot/',
  _links_products_ai_agents: '/de/produkte/ai-agent/',

  _links_company_about_us: '/de/unternehmen/ueber-uns/',
  _links_company_jobs: '/de/unternehmen/jobs/',
  _links_company_imprint: '/de/unternehmen/impressum/',
  _links_company_data_privacy: '/de/unternehmen/datenschutz/',
  _links_company_contact: '/de/unternehmen/kontakt/',

  _links_navigation_cta_button: '/de/landing-pages/konto-anlegen/',

  _video_fallback:
    'Dieser Browser unterstützt leider keine Videos. Du kannst das Video hier ansehen.',

  _audio_fallback:
    'Dieser Browser unterstützt leider dieses Audio Format nicht. Du kannst die Datei hier herunterladen.',

  _cookie_consent_settings: 'Cookie Einstellungen',
  _cookie_consent_text:
    'Wir setzen Cookies ein, um die Nutzung unserer Webseiten zu analysieren, einschließlich des Such und Surfverlaufs, Suchbegriffen und Ihnen auf Ihr Nutzungsverhalten angepasste Informationen anbieten zu können.',
  _cookie_consent_link: 'https://omq.ai/de/unternehmen/datenschutz/',
  _cookie_consent_link_text: 'Lernen Sie mehr',
  _cookie_consent_button_all_text: 'Alle Cookies erlauben',
  _cookie_consent_button_function_text: 'Nur funktionale Cookies',

  _top_banner_button_mobile: 'Abonnieren',
  _top_banner_button_desktop: 'Newsletter abonnieren',

  _glossary_title: 'Lexikon',
  _glossary_description:
    'Wissenswertes zu Chatbots, Künstlicher Intelligenz und Conversational AI. Von A bis Z.',
  _glossary_intro_image_alt: 'Frau mit einem Smartphone in der Hand',
  _glossary_intro_headline: 'Chatbot-Lexikon',
  _glossary_intro_text:
    'Wissenswertes zu Chatbots, Künstlicher Intelligenz und Conversational AI. Von A bis Z.',
  _glossary_clear_filter: 'Filter löschen',
  _glossary_all_articles: 'Alle Artikel',
  _glossary_back_to: 'Zurück zum Lexikon',
};
